/**
 * Labstep
 *
 * @module screens/Tag/Index
 * @desc Tag manager page
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { TagActionCreate } from 'labstep-web/components/Tag/Action/Create';
import { TagEmptyState } from 'labstep-web/components/Tag/EmptyState';
import { TagTable } from 'labstep-web/components/Tag/Table';
import { Filter } from 'labstep-web/constants/filters';
import { Tag } from 'labstep-web/models/tag.model';
import type React from 'react';
import { useMemo } from 'react';
import type { ITagIndexProps } from './types';

export const TagIndex: React.FC<ITagIndexProps> = ({
  group,
  type,
}) => {
  const params = useMemo(
    () => ({ group_id: group.id, type }),
    [group.id],
  );
  const action = useMemo(
    () => <TagActionCreate defaultType={type} />,
    [],
  );
  const noResultsMessage = useMemo(
    () => <TagEmptyState type={type} />,
    [],
  );
  return (
    <EntitySearch
      entityName={Tag.entityName}
      params={params}
      tableFormat
      action={action}
      filters={[Filter.deleted, Filter.created_by]}
      noResultsMessage={noResultsMessage}
      bulkActions={[BulkAction.delete]}
    >
      {({ entities, ...rest }): React.ReactElement => (
        <TagTable tags={entities} {...rest} />
      )}
    </EntitySearch>
  );
};
